import React, { useEffect } from 'react';
import styled from 'styled-components';
import { COLORS, ComponentL, ComponentXXS, SystemIcons } from '@laerdal/life-react-components';
import { useTranslation } from 'react-i18next';
import { StepContainer } from './StepComponents';
import { useNavigate } from 'react-router';
import posthog from 'posthog-js';
import BreadcrumbTopSection from '../../../../commonComponents/BreadcrumbTopSection';
import { buildMarketPath, selectMarket } from '../../../../store/slices/globalConfigSlice';
import { useSelector } from 'react-redux';

const Container = styled.div`
    display: flex;
    padding: 32px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    align-self: stretch;

    border-radius: 8px;
    background: #FFF;

`;



const IconContainer = styled.div`
    display: flex;
    width: 64px;
    height: 64px;
    justify-content: center;
    align-items: center;
    gap: 8px;

    border-radius: 64px;
    border: 2px solid ${COLORS.positive_500};
`;

interface Step10Props {
  caseNumber: string;
  category: string;
}

const Step10: React.FC<Step10Props> = ({ caseNumber, category }) => {
  const { t } = useTranslation(['translation', 'qcprSupport']);
  const navigate = useNavigate();
  const currentMarket = useSelector(selectMarket);

  useEffect(() => {
    // Track successful case creation page visit
    posthog.capture('SUPP-QcprSupport-TroubleshootingCompletedPageVisit', {
      step: 10,
      case_number: caseNumber,
      category: category
    });
  }, [caseNumber, category]);

  const handleBackClick = () => {
    posthog.capture('SUPP-QcprSupport-TroubleshootingCompletedBackClicked', {
      step: 10,
      case_number: caseNumber,
      category: category
    });
    navigate('/qcpr-support');
  };

  return (
    <>
      <StepContainer>
        <BreadcrumbTopSection
          setPadding={false}
          breadcrumb={[
            { text: t('Home', { ns: 'qcprSupport' }), link: buildMarketPath(currentMarket, '/') },
            { text: t('Software and Apps', { ns: 'qcprSupport' }), link: buildMarketPath(currentMarket, '/category/software-and-apps') },
            { text: t('QCPR App', { ns: 'qcprSupport' }), link: buildMarketPath(currentMarket, '/category/software-and-apps/product/qcpr-app') },
            { text: t('Troubleshooting', { ns: 'qcprSupport' }) }
          ]}
        />

        <Container>
          <IconContainer>
            <SystemIcons.CheckMark size='32px' color={COLORS.positive_500} />
          </IconContainer>
          <ComponentL>
            {t("Thank you for contacting us", { ns: 'qcprSupport' })}
          </ComponentL>
          <ComponentXXS>
            {t("Case number: {{caseNumber}}", { ns: 'qcprSupport', caseNumber })}
          </ComponentXXS>
          <ComponentXXS>
            {t("Your case has been created, and our team will respond within 24 hours.", { ns: 'qcprSupport' })}
          </ComponentXXS>
        </Container>
      </StepContainer>
    </>
  );
};

export default Step10;
